import styled, { createGlobalStyle } from 'styled-components';

import { StyledModalDialog, token } from '@zillow/constellation';

export const StyledContainer = styled.div`
    background-color: ${token('colors.gray100')};
`;

export const StyledFooterContainer = styled.div`
    background-color: ${token('colors.white')};
`;

export const GlobalStyle = createGlobalStyle`
    ${StyledModalDialog} {
        &&& {
            header {
                border-bottom: 1px solid ${token('colors.gray300')};
                padding: 16px 48px;
            }

            section > button {
                color: #001751;
                width: 24px;
                height: 24px;
                > svg {
                    width: 24px;
                    height: 24px;
                }
            }
        }
    }
    
`;
